(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('PocCobranca', PocCobranca);

  PocCobranca.$inject = ['$resource'];

  function PocCobranca ($resource) {
    return $resource(apiUrl + '/poc-cobranca/:id', { id: '@id' }, {
      'query': { method: 'GET', isArray: false },
      'update': { method: 'PUT' }
    });
  }

  angular.module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
      , 'foundation'
    );

  angular.module('MktzapApp.Controllers')
    .controller('PocCobrancaController', cobranca);

  cobranca.$inject = ['$scope', 'FoundationApi', 'LangService', '$http', 'PocCobranca', 'ngTableParams'];

  function cobranca ($scope, FoundationApi, LangService, $http, PocCobranca, ngTableParams) {
    var vm = this;

    LangService
      .getPageLabels({ 'page': 'poc.cobranca' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    vm.open = open;
    vm.edit = edit;
    vm.remove = remove;

    vm.modal = {
      title: 'Editar',
      cobranca: {},
      create: createCobranca,
      save: editCobranca,
      remove: removeCobranca,
      mode: ''
    };

    vm.pocsTable = new ngTableParams({
      page: 1, // show first page
      count: 10 // count per page
    }, {
      getData: function ($defer, params) {
        PocCobranca.query()
          .$promise.then(
            // success
            function (response, status, headers, config) {
              params.total(response.total);
              $defer.resolve(response.data);
            },
            // error
            function (error) { /* Do something with error */ }
          );
      }
    });

    function open (cobranca) {
      vm.modal.mode = 'create';
      vm.modal.cobranca = {};
      FoundationApi.publish('dlgPocCobranca', 'open');
    }

    function edit (cobranca) {
      vm.modal.mode = 'edit';
      vm.modal.cobranca = angular.copy(cobranca);
      FoundationApi.publish('dlgPocCobranca', 'open');
    }

    function remove (cobranca) {
      vm.modal.cobranca = angular.copy(cobranca);
      FoundationApi.publish('dlgDeletar', 'open');
    }

    function createCobranca () {
      PocCobranca.save(vm.modal.cobranca, function () {
        vm.pocsTable.reload();
        FoundationApi.publish('dlgPocCobranca', 'close');

        FoundationApi.publish('main-notifications', {
          title: vm.labels.createdSuccess,
          content: vm.labels.created,
          color: 'success'
        });
      });
    }

    function editCobranca () {
      PocCobranca.update(vm.modal.cobranca, function () {
        vm.pocsTable.reload();
        FoundationApi.publish('dlgPocCobranca', 'close');

        FoundationApi.publish('main-notifications', {
          title: vm.labels.editedSuccess,
          content: vm.labels.edited,
          color: 'success'
        });
      });
    }

    function removeCobranca () {
      PocCobranca.delete(vm.modal.cobranca, function () {
        vm.pocsTable.reload();
        FoundationApi.publish('dlgDeletar', 'close');

        FoundationApi.publish('main-notifications', {
          title: vm.labels.removedSuccess,
          content: vm.labels.removed,
          color: 'success'
        });
      });
    }
  }
})();
